/* eslint-disable react/prop-types */

import React from 'react';
import { Col, Row } from 'reactstrap';
import LockupSection from './LockupSection';

const SponsorLockup = ({ page }) => (
  <div id="footer">
    <Row>
      <Col className="text-center" md={12}>
        <LockupSection text={page.sponsorLockupText1} logo={page.sponsorLockupLogo1} />
        <LockupSection text={page.sponsorLockupText2} logo={page.sponsorLockupLogo2} />
        <LockupSection text={page.sponsorLockupText3} logo={page.sponsorLockupLogo3} />
        <LockupSection text={page.sponsorLockupText4} logo={page.sponsorLockupLogo4} />
      </Col>
    </Row>
  </div>
);

export default SponsorLockup;
